import { observable, action } from "mobx"

class SnackbarStore {
  @observable open = false
  @observable message = ""
  @observable severity = "success"
  @observable verticalPosition = "top"

  @action
  showSnackbar = (message, severity, verticalPosition = "top") => {
    this.message = message
    this.open = true
    this.severity = severity
    this.verticalPosition = verticalPosition
  }

  @action
  closeSnackbar = () => {
    this.open = false
    this.message = ""
  }
}

export default new SnackbarStore()
